import React from "react";

export default function Third() {
  return (
    <section>
      <img src="images/home/sec3-bg.webp" alt="bg" className="w-full" />
    </section>
  );
}
